import { mergeStyles, Text } from '@fluentui/react';
import * as React from 'react';
import { isGetHelpSourceApp } from '../../../../web/utils/statelessUtil';
import { isBranded } from '../../../utilities';
import { getCommonClassNames, getCommonStyles } from '../styles/commonStyles';
import { IFormHeaderStyles, getFormHeaderClassNames, getFormHeaderStyles } from '../styles/formHeaderStyles';
import { IStyledComponent } from '../styles/themesUI';
import { SectionHeader, SectionHeaderProps } from './SectionHeader';
import { getString } from '../../../../web/utils/stringLoader';
import { EduConfig } from '../../../../web/edu/eduConfig';
import { SourceApps, URLs } from '../../../models/constants/constants';
import UpdateBanner from '../../../../web/common/components/UpdateBanner';
interface FormProps {
    runningInSoc: boolean;
    isNonAgave: boolean;
    isUnifiedPremier: boolean;
    isUnifiedEnterprisePremier: boolean;
    isNonUnifiedPremier: boolean;
    isPremierTenantEnabled: boolean;
    isSMCExperiment: boolean;
    appName: string;
    signInContactSupport: string;
    showSectionHeader: boolean;
    isBATenant: boolean;
    isBusinessAssistUXEnabled: boolean;
    eduProductId: string;
    isTeams: boolean;
    sourceApp: SourceApps;
}

const commonClassNames = getCommonClassNames(getCommonStyles!, {});

const SocFormHeader = (props: { headerText: string }) => {
    const formClassName = getFormHeaderClassNames(getFormHeaderStyles);
    return (
        <div className={mergeStyles(commonClassNames.textNormal, formClassName.row)}>
            <div className={formClassName.formColLgTen} id="help-content-title"><h1 tabIndex={-1}>{props.headerText}</h1></div>
        </div>
    );
};

type IFormHeaderProps = FormProps & IStyledComponent<IFormHeaderStyles>

export class FormHeader extends React.Component<IFormHeaderProps> {
    public constructor(props: IFormHeaderProps) {
        super(props);
    }

    private contactUsFormClassName = getFormHeaderClassNames(getFormHeaderStyles, {
        isNonAgave: this.props.isNonAgave,
        appName: this.props.appName,
    });

    private handleTeamsBannerButtonClick = () => {
        window.open(URLs.TeamsUpdatedVersion);
    }

    public render() {
        /**
         * If the application is brandable, then this header won't be displayed because there will be a branded header in the app body
         */
        if (isBranded(this.props.appName)) {
            return null;
        }

        if (this.props.showSectionHeader) {
            const descriptionProps: Partial<SectionHeaderProps> = {};
            const eduProduct = EduConfig.products[this.props.eduProductId];

            if (eduProduct) {
                const eduProductOrOther = getString('search_socSMCExperimentContactUsFormSectionDescription_eduProductAndOther').replace('{0}', eduProduct.name);
                const descriptionParts = getString('search_socSMCExperimentContactUsFormSectionDescriptionWithEduProduct').split('{0}');
                descriptionProps.descriptionElement = (
                    <Text>
                        {descriptionParts[0]}
                        <strong>{eduProductOrOther}</strong>
                        {descriptionParts[1]}
                    </Text>
                );
            } else {
                descriptionProps.description = getString('search_socSMCExperimentContactUsFormSectionDescription');
            }

            return (
                <div className={mergeStyles(commonClassNames.textNormal, this.contactUsFormClassName.formColLgTen, this.contactUsFormClassName.formSearchHelpMainHeader)}>
                    {this.props.sourceApp === SourceApps.Teams && (
                        <UpdateBanner
                            isTeams={this.props.isTeams}
                            updateDate={new Date(2024, 10, 15)} // November 15th 2024
                            handleButtonClick={this.handleTeamsBannerButtonClick}
                        />)
                    }
                    <SectionHeader
                        title={getString('search_socSMCExperimentContactUsFormSectionTitle')}
                        theme={this.props.theme}
                        isUnifiedPremier={this.props.isUnifiedPremier}
                        isUnifiedEnterprisePremier={this.props.isUnifiedEnterprisePremier}
                        isNonUnifiedPremier={this.props.isNonUnifiedPremier}
                        isPremierTenantEnabled={this.props.isPremierTenantEnabled}
                        largeFrontPageTitle={isGetHelpSourceApp(this.props.appName)}
                        isBATenant={this.props.isBATenant}
                        isBusinessAssistUXEnabled={this.props.isBusinessAssistUXEnabled}
                        {...descriptionProps}
                    />
                </div>
            );
        }

        if (this.props.runningInSoc) {
            return (
                <SocFormHeader headerText={this.props.isSMCExperiment
                  ? getString('search_socSMCExperimentContactUsFormDescription')
                  : getString('search_socContactUsFormDescription')} />
            );
        } else {
            return (
                <SocFormHeader headerText={getString('search_contactUsFormDescription').replace('&#39;', '\'')} />
            );
        }
    }
}
